<div class="kpiContainer" [hidden]="isNoMetric || isDateRangeTooWideIntraDay">
    <div [ngClass]="[(view === 0) ? 'kpiWrapperHorizontal' : 'kpiWrapperVertical', isCXOne ? 'cxOneWrapper' : '']">
        <div *ngFor="let obj of objs" class="d-flex kpiItemContainer">
            <div *ngIf="!isCXOne" class="kpiItem">
                <div class="kpiItemValue" [ngStyle]="{ 'background-color': obj.color, 'border': obj.color ? 'none' : 'inherit' }">
                    {{ obj.metricData.MetricDisplayValue ? obj.metricData.MetricDisplayValue : 0 }}
                    <button
                        *ngIf="obj.metricData.objectiveData && obj.metricData.objectiveData.poColors" 
                        type="button"
                        class="icon-btn cv-context-menu-icon-hideable fill-moreDark hover-visible"
                        [matMenuTriggerFor]="contextMenu">
                        <svg class="icon-12">
                            <use href="../App_Themes/clearview-default/icons/utility/more.svg#more"></use>
                        </svg>
                    </button>
                    <mat-menu #contextMenu="matMenu" class="custom-mat-menu">
                        <button mat-menu-item
                                (click)="openObjectivesDetailsModal(obj)">
                            <svg class="icon-16" style="fill: #6a7480;">
                                <use href="../App_Themes/clearview-default/icons/dashboard/gauge-range.svg#gauge-range"></use>
                           </svg>
                           <span cvLocalizedText langSection="Objectives" langKey="Objectives_Details" class="ml-2">Objectives Details</span>
                        </button>
                    </mat-menu>
                </div>
                <div class="kpiItemNameContainer" [attr.title]="getMetricToolTip(obj)">
                    <span class="kpiItemName">{{ getMetricDisplayName(obj) }}</span>
                </div>
            </div>

            <div #cxOneItem class="cxOneItemRow" *ngIf="isCXOne">
                <div class="cxOneItemCard">
                    <div class="cxOneItemCol text-center">
                        <div class="cxOneItemValueContainer" [ngStyle]="{'background-color': obj.color }">
                            <span class="cxoneValueText">{{ obj.metricData.MetricDisplayValue ? obj.metricData.MetricDisplayValue : 0 }}</span>
                        </div>
                    </div>
                    <div class="cxOneItemCol text-center">
                        <div class="cxOneItemNameContainer">
                            <span class="cxoneNameText">{{ obj.metric.Abbreviation}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-module-error class="flex-fill" *ngIf=isNoMetric [noMetric]="true"></app-module-error>
<app-module-error class="flex-fill" *ngIf=isDateRangeTooWideIntraDay [dateRangeTooWideIntraday]="true"></app-module-error>
<app-module-error class="flex-fill" *ngIf="noData && !isNoMetric" [noData]="true"></app-module-error>
